import { Form, Input } from "antd";
import { FC } from "react";
import { ConfirmButtons, Modal } from "../../../../ui";
import "./index.less";
import { useEffect, useState } from "react";

interface EditColumnModalProps {
  onClose: () => void;
  currentGroup;
  editColumnTitle;
  dealsGroup;
}

export const EditColumnModal: FC<EditColumnModalProps> = ({ onClose, currentGroup, editColumnTitle, dealsGroup }) => {
  const [form] = Form.useForm();
  const [disableSave, setDisableSave] = useState(true);

  const titleValue = Form.useWatch("title", form);

  useEffect(() => {
    console.log(titleValue, "titleValuetitleValue", dealsGroup);
    // const normalizedCurrent = currentGroup?.title?.trim()?.toLowerCase();
    const normalizedInput = titleValue?.trim()?.toLowerCase();
    console.log(
      "titleValuetitleValue22",
      dealsGroup?.some((gr) => gr?.id !== currentGroup?.id && normalizedInput === gr?.title?.trim()?.toLowerCase())
    );
    setDisableSave(dealsGroup?.some((gr) => gr?.id !== currentGroup?.id && normalizedInput === gr?.title?.trim()?.toLowerCase()));
  }, [titleValue, currentGroup]);

  const handleSubmitBtnClick = () => {
    form
      .validateFields()
      .then((values) => {
        editColumnTitle(values.title);
        onClose();
      })
      .catch((errorInfo) => {
        console.error("Validation failed:", errorInfo);
      });
  };

  return (
    <Modal open={true} title={"Edit Column"} onCancel={onClose} rootClassName={"edit-column-modal"}>
      <Form form={form} layout={"vertical"} requiredMark={false} className={"edit-column-form"} initialValues={{ title: currentGroup?.title }}>
        <Form.Item
          name={"title"}
          label={"Name"}
          rules={[
            { required: true, message: "Title is required" },
            {
              validator: (_, value) => {
                if (!value || value === currentGroup?.title) return Promise.resolve();
                const isDuplicate = dealsGroup?.some((group) => group?.title?.trim()?.toLowerCase() === value?.trim()?.toLowerCase());
                return isDuplicate ? Promise.reject("This column title already exists.") : Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder={"Enter Text"} />
        </Form.Item>
      </Form>
      <ConfirmButtons
        leftButtonTitle={"Back"}
        rightButtonTitle={"Save"}
        className={"confirm-buttons"}
        handleSubmit={handleSubmitBtnClick}
        onCancel={onClose}
        disabled={disableSave}
      />
    </Modal>
  );
};
